import { FoundationsConstants } from "../FoundationsConstants";
import { useGetFilteredUsersShareMutation, useShareDashboardUsersMutation } from "../Redux/Workspace/workspaceActionsSlice";
import { FoundationsGenericToaster } from "./FoundationsGenericToaster";
import { SearchListCallbacks } from "./searchlistCallbacks";
declare let window: any
const UnicornApp = window.unicornInstance as any

export const ShareDashboardCallbacks = (dashBoardId: number, onShareSuccess?: () => void): SearchListCallbacks => {
    const [getFilteredUsersShare] = useGetFilteredUsersShareMutation();
    const [shareDashboardUsers] = useShareDashboardUsersMutation();

    const onFind = async (filterText: string) => {
        const formData = new FormData();
        formData.append('dashBoardId', dashBoardId.toString());
        formData.append('searchstring', filterText);
        const response = await getFilteredUsersShare(formData).unwrap();
        if (response.length === 0) {
            return "Sorry, no matches found. Try a different search.";
        }    
        return response.map((item: { KeyValue: any; DisplayText: any; }) => ({
            KeyValue: item.KeyValue,
            DisplayText: item.DisplayText,
        }));
    };

    const onSave = async (selectedItems: any[]) => {
        const userIds = selectedItems.map((item) => item.KeyValue);
        const formData = new FormData();
        formData.append('dashBoardId', dashBoardId.toString());
        userIds.forEach((id) => formData.append('userId', id));

        try {
            const response = await shareDashboardUsers(formData).unwrap();

            if (response?.statusCode === 204) {
                const resultData = response.data;
                if (resultData) {
                    FoundationsGenericToaster(
                        'success',
                        FoundationsConstants.toastrMessage.workspacesharesuccess
                    );
                    onShareSuccess?.();
                }
            } else if (
                response?.status?.OperationCode === "OperationNotAllowed"
            ) {
                window.healthLevelGlobal.handleOperationNotAllowedMessage();
            } else {
                FoundationsGenericToaster(
                    'error',
                    FoundationsConstants.toastrMessage.workspacesharefailure
                );
            }
        } catch (error) {
            window.healthLevelGlobal.handleAjaxPopupError(null, error);
            FoundationsGenericToaster(
                'error',
                FoundationsConstants.toastrMessage.workspacesharefailure
            );
        }
    };


    return {
        onFind,
        onSave,
    };
};